const getPurchasesUrl = (filterType) =>
  filterType === "HIDDEN"
    ? "/hiddenLots"
    : filterType === "TAG"
    ? "/markedLots"
    : "/lots";

export { getPurchasesUrl };
